import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../shared/config/app-config';
import { Puser, User, UserService } from '../../shared';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-assement',
  templateUrl: './passement.component.html',
  styleUrls: ['./passement.component.css']
})
export class PAssementComponent implements OnInit {
  success: MatDialogRef<SucesstempComponent>;
  imageURL: string = environment.cloudeImageURL;
  maxdate: boolean;
  togglepattern: any;
  showinvaild: boolean;
  pattern: any;
  enableques: boolean = false;
  patdis: any;
  public name: any;
  
  checkvalid(value) {
  }
  
  // Function to check if all inner questions are answered
  areAllInnerQuestionsAnswered(): boolean {
     // Check if ALL visible inner questions are answered (both textbox and radio types)
     if (!this.inner || !this.inneransvalue) {
      return false;
    }
    
    // Check each inner question
    for (let i = 0; i < this.inner.length; i++) {
      const innerGroup = this.inner[i];
      const innerValue = this.inneransvalue[i];
      
      if (!innerGroup || !innerValue) {
        return false;
      }
      
      // Skip validation for conditional questions that are hidden
      // Questions with innerChoicePk 25, 28, 31, 34 are conditional and shown only when enableques is true
      const isConditionalQuestion = innerGroup.innerChoicePk && [25, 28, 31, 34].includes(innerGroup.innerChoicePk);
      if (isConditionalQuestion && !this.enableques) {
        // This question is hidden, skip validation
        continue;
      }
      
      // For textbox type questions
      if (innerGroup.innerQuestionType && innerGroup.innerQuestionType.toLowerCase() === 'textbox') {
        const innerValueObj : any = innerValue.innerAnswerValue;
        
        
        // Check if all textbox fields have values
        if (innerGroup.innerAnsChNameArray) {
          const allTextboxesFilled = innerGroup.innerAnsChNameArray.every(ans => {
            const value = typeof innerValueObj == "string" ? innerValueObj : [ans.innerAnsChName];
            return this.isInnerAnswerFilled(value);
          });
          
          if (!allTextboxesFilled) {
            return false;
          }
        }
      }
      // For radio type questions
      else if (innerGroup.innerQuestionType && innerGroup.innerQuestionType.toLowerCase() === 'radio') {
        // Check if an answer is selected (innerAnswerValue should not be "null" or empty)
        if (!this.isInnerAnswerFilled(innerValue.innerAnswerValue)) {
          return false;
        }
      }
    }
    
    return true;
  }

  isInnerAnswerFilled(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      const normalized = value.trim();
      if (normalized === '' || normalized.toLowerCase() === 'null') {
        return false;
      }
    }
    return true;
  }

  menustatus: boolean = false;
  twowaymsg: boolean = false;
  chckinsurvey: boolean = false;

  menu: any;
  resp: any;
  survey: any;
  mulans: any;
  option: any;
  enable: boolean = false;
  timeset: any = environment.timelimit
  apiurl: any = environment.api_url
  pathid: any;
  surveyques: any;
  intro: any;
  padding: any;
  ques: any;
  anstype: any;
  inner: any;
  inneransvalue: any;
  savesurvey: any;
  answer: any = [];
  public inputsurvey: any = {};
  ansvalue: any;
  modalRef: BsModalRef;
  ans: any;
  associateSurveyDetails: any
  associateReviewConditions: any = ['In-Progress', 'Up to speed', 'Falling Behind']
  assigned: any;
  slideval: any;
  result: any;
  number: any;
  type: any;
  complete = false;
  enablepage = false;
  public object: any;
  CurrentUser: User;
  PUser: Puser;
  public bobMinDate = new Date(window.localStorage['patDob'])
  public bobMaxDate = new Date();
  public dateformat = environment.dateFormat;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  private subscription: Subscription;
  private timer: Observable<any>;
  introonly: boolean;
  previousintro: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private userService: UserService,
    private datepipe: DatePipe,
    private dialog: MatDialog,
  ) { }
  ngOnInit() {
    this.associateSurveyDetails = this.userService.getTemporaryData()
    this.name = JSON.parse(atob(window.localStorage['assesDetails']))
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        if (this.CurrentUser.item) {
          if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
        }
      }
    )
    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    this.userService
      .fetchCkChForPatDisclaimer('Assessment', this.name.name)
      .subscribe(
        data => {

          this.patdis = data.patDisclaimer;
          //////console.log(this.patdis)

          // alert(this.patdis.patDisclaimer)
        }

      );

    ////////console.log(this.route.snapshot.url[0].path)
    this.getmenu()
    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        this.PUser = puserData;

      }
    )
    this.userService
      .getactivity(window.localStorage['Puser'])
      .subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].data.length; j++) {
              if (data[i].data[j].materialHspPatientMappingId == this.name.name) {
                this.pathid = data[i].data[j].materialId;
              }

            }
          }

        }

      );
    this.userService.getassignedbydetails(this.name.materialId, 'survey')
      .subscribe(
        data => {

          this.assigned = data
          ////////console.log(data)
          if (this.route.snapshot.url[0].path == 'assessment') {
            this.CurrentUser.operationStatus = 'material'
            /* if (this.assigned.userRole == 'Care Coordinator' || this.assigned.userRole == 'Care Outcomes Manager') */
            if (this.assigned.userRole == 'Care Coordinator') {
              this.assigned.userRole = 'Care Navigator'
            }
            this.CurrentUser.operationMessage = this.userService.translateText('patient_portal.display_messages.requested_by.label')+'&nbsp;:&nbsp;' + this.assigned.name + '&nbsp; <img alt="" class="rounded-circle pl" title="' + this.assigned.name + '" src="' + this.imageURL + this.assigned.userImagePath + '"> &nbsp;'
          }
        });
    if (this.name.name) {
      this.userService
        .getsurvey(this.name.name, window.localStorage['Puser'], 1)
        .subscribe(
          data => {
            let self = this
            self.survey = data;
            self.enablepage = true;
            var answer
            if (data) {
              self.result = data[1].result;
              self.surveyques = data[0].survey;
              if (self.surveyques.name.search(this.userService.translateText('patient_portal.assessment.recovery_goals.label')) != -1)
                self.introonly = false
              else
                self.introonly = true
              //self.number = data[0].survey.sQuestion.length;
              self.number = 0
              data[0].survey.sQuestion.forEach((element) => {
                if (element.active == '1')
                  self.number = self.number + 1
              });
              if (self.number == 1)
                self.complete = true;
              let index = 0
            for (var g = 0; g < data[1].result.length; g++) {
                if ((data[1].result[g].resultAnswerType.toLowerCase() == 'single' && data[1].result[g].resultChoicetypeId == "" && !data[1].result[g].resultIsSkipped) || (data[1].result[g].resultAnswerType.toLowerCase() == 'textbox' && (data[1].result[g].resultAnswerValue == "null" || data[1].result[g].resultAnswerValue == "") && !data[1].result[g].resultIsSkipped) || ((data[1].result[g].resultAnswerType.toLowerCase() == 'sliderbar' || data[1].result[g].resultAnswerType.toLowerCase() == 'c_sliderbar' || data[1].result[g].resultAnswerType.toLowerCase() == 'slider') && (data[1].result[g].resultAnswerValue == "null" || data[1].result[g].resultAnswerValue == "") && !data[1].result[g].resultIsSkipped) || (data[1].result[g].resultAnswerType.toLowerCase() == 'datetime' && (data[1].result[g].resultAnswerValue == "null" || data[1].result[g].resultAnswerValue == "") && !data[1].result[g].resultIsSkipped)) {
                  index = g
                  break;
                } else if (((data[1].result[g].resultAnswerType.toLowerCase() == 'multiplercsd' || data[1].result[g].resultAnswerType.toLowerCase() == 'multiple') && data[1].result[g].multiResult && !data[1].result[g].resultIsSkipped) || (data[1].result[g].resultAnswerType.toLowerCase() == 'singlenewyn' && data[1].result[g].multiResult && !data[1].result[g].resultIsSkipped)) {
                  let ind = _.findIndex(data[1].result[g].multiResult, (o: any): any => {
                    return o.mulAnswerValue != "null"
                  })
                  if (ind == -1) {
                    index = g
                    break;
                  }
                }
              }
              for (var g = 0; g < data[1].result.length; g++) {
                if (data[1].result[g].resultAnswerValue == 'null' && data[0].survey.sQuestion[g].questiontype.toLowerCase().includes('slider')) {
                  data[1].result[g].resultAnswerValue = "0"
                }
              }
              if (index == 0)
                self.intro = data[0].survey.introduction;
              if (self.number - 1 == index)
                self.complete = true;
              self.ques = data[0].survey.sQuestion[index];
              if (self.ques) {
                if ((self.ques.questiontype.toLowerCase()) == 'multiplercsd' || (self.ques.questiontype.toLowerCase()) == 'multiple')
                  self.padding = '13px'
                else
                  self.padding = '68px'
                if (((self.ques.questiontype.toLowerCase()) == 'single') || ((self.ques.questiontype.toLowerCase()) == 'singlenewyn')) {
                  self.complete = false;
                  if (self.getresult(self.result, self.ques).resultChoicetypeId != 0)
                    self.option = true
                }
                self.ans = data[0].survey.sQuestion[index].sAnswer;
                if (self.ans.innerChoice) {
                  self.inner = self.ans.innerChoice
                  self.inneransvalue = self.getresult(self.result, self.ques).InnerResult
                }
                self.ansvalue = self.getresult(self.result, self.ques);
                let input;
                if ((self.ques.questiontype.toLowerCase()) == 'textbox' && (self.ques.questionId == 1065 || self.ques.questionId == 1225 || self.ques.questionId == 806)) {

                  if (self.ansvalue.resultAnswerValue != 'null') {
                    answer = self.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'height': answer[0],
                      'feet': answer[2]
                    }
                  }
                  else {
                    input = {
                      'height': '',
                      'feet': ''
                    }
                  }
                }
                else if ((self.ques.questiontype.toLowerCase()) == 'textbox' && (self.ques.questionId == 1066 || self.ques.questionId == 1226 || self.ques.questionId == 807)) {

                  if (self.ansvalue.resultAnswerValue != 'null') {
                    answer = self.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'input': answer[0]
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                else {
                  if (self.ansvalue.resultAnswerValue != 'null' && self.ques.questiontype.toLowerCase() != 'datetime') {
                    input = {
                      'input': self.ansvalue.resultAnswerValue
                    }
                  } else if (self.ques.questiontype.toLowerCase() == 'datetime' && self.ansvalue.resultAnswerValue != 'null') {
                    input = {
                      'input': new Date(self.ansvalue.resultAnswerValue)
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                self.inputsurvey = input; //////console.log(self.inputsurvey)
                ////////console.log(self.inputsurvey)

              }




            }


          }

        );
    }


  }
  nextsingleques(anstype, m, innerchoice, event) {
    setTimeout(() => {
      this.nextSQues(anstype, m, innerchoice, event)
    }, 300)
  }
  nextSQues(anstype, m, innerchoice, event) {
    this.option = false

    if (event) {
      ////////console.log(anstype.ansChoicetypeId)
      if (event != 'y') {
        event = 0
      }
      else {
        event = 1
      }
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        var result = this.getresult(this.result, this.ques)

        for (var j = 0; j < this.getresult(this.result, this.ques).multiResult.length; j++) {
          if (this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == this.userService.translateText('hospital_portal.profile.none.label') || this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == this.userService.translateText('patient_portal.question.didnt_experienced_complications')) {
            this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue = "null"
            this.getresult(this.result, this.ques).multiResult[j].mulChoicetypeId = 0
            this.getresult(this.result, this.ques).multiResult[j].mulScoreValue = "null"
          }
        }

        this.getresult(this.result, this.ques).multiResult[m].mulAnswerValue = anstype.choicetype
        if (event == 1) {
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = anstype.ansChoicetypeId
        }
        else {
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = 0
        }
        this.getresult(this.result, this.ques).multiResult[m].mulScoreValue = event
        this.getresult(this.result, this.ques).resultIsSkipped = false
        if (!anstype.innerChoice) {
          for (var s = 0; s < this.getresult(this.result, this.ques).InnerResult.length; s++) {
            this.getresult(this.result, this.ques).InnerResult[s].innerAnswerValue = "null"
          }
        }
      }

      if (anstype.innerChoice) {
        this.inner = anstype.innerChoice
        this.anstype = anstype
        if (result.InnerResult[0]) {
          this.inneransvalue = result.InnerResult

        }
        ////////console.log(this.inner)

        this.modalRef = this.modalService.show(innerchoice, { backdrop: 'static' });
        this.movable()
      }
    }


  }
  nextSingleQues(id, popup: TemplateRef<any>) {
    this.option = false
    this.mulans = false;
    var answer;
    let index = _.findIndex(this.result[id - 1].multiResult, (o: any): any => {
      return o.mulAnswerValue == "null"
    })
    if (index == -1) {
      let number: string = id;
      this.userService
        .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
        .subscribe(
          data => {
            this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
          }

        );
      if (number >= this.number) {
        this.complete = true;
        this.completesurvey(popup);

      }
      else {
        id = id + 1;


        for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {

          var ans
          for (var l = 0; l < this.ans.length; l++) {
            if (this.ans[l].ForwardSkipQusId != null) {

              ans = this.ans[l].ForwardSkipQusId
            }
          }
          if (ans == "" || !ans) {
            if (id == this.survey[0].survey.sQuestion[j].qNumber) {
              this.ans = [];
              this.ques = [];
              this.intro = null;
              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'single')
                this.complete = false
              this.mulans = null;
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
                this.complete = false
              this.mulans = null;
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = [];
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              let input;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; //////console.log(this.inputsurvey)
              break;
            }
          }
          else if (ans == this.survey[0].survey.sQuestion[j].questionId) {
            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (ans == forwardid) {
                break;
              }


            }
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = [];
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; //////console.log(this.inputsurvey)
            break;
          }
          if (number + 1 >= this.number)
            this.complete = true;


        }

      }
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_answer_all_question.error'));
    }

  }
  nextques(id, anstype, innerchoice, popup) {
    let number: string = id;
    if (number >= this.number) {
      this.enablepage = false;
    }
    setTimeout(() => {
      this.nextQues(id, anstype, innerchoice, popup)
    }, 300)
  }
  nextQues(id, anstype, innerchoice, popup) {
    this.option = false
    var answer
    if (anstype) {
      let number: string = id;
      if (this.surveyques.branchPattern) {
        this.togglepattern = this.surveyques.branchPattern.split('~BR~');
        for (var f = 0; f < this.togglepattern.length; f++) {
          if (this.togglepattern[f].includes('TOGGLE###qpk')) {
            this.pattern = this.togglepattern[f].split('|');
            if (this.pattern[1])
              var branchques = this.pattern[1].split('_')
            if (branchques[0] == this.ques.questionId) {
              if (this.pattern[2]) {
                var ans = this.pattern[2].split('#')
                if (ans[0].includes('^')) {
                  ans = ans[0].split('^')
                  ans.forEach(ansItem => {
                    if (ansItem == anstype.ansChoicetypeId) {
                      number = this.number
                      this.getresult(this.result, this.ques).resultIsSkipped = true
                      this.getresult(this.result, this.ques).resultAnswerValue = ''
                      for (var qs = id; qs < this.result.length; qs++) {
                        this.result[qs].resultAnswerValue = ''
                        this.result[qs].InnerResult = [];
                        this.result[qs].multiResult = [];
                        this.result[qs].resultAnswerId = 0
                        this.result[qs].resultChoicetypeId = 0
                        this.result[qs].resultScoreValue = ''
                      }
                    }
                  })
                } else {
                  if (ans[0] == anstype.ansChoicetypeId) {
                    number = this.number
                    this.getresult(this.result, this.ques).resultIsSkipped = true
                    this.getresult(this.result, this.ques).resultAnswerValue = ''
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                }

              }
            }
          }
        }
      }
      this.answer[id] = anstype
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).resultAnswerId = anstype.scoreId ? anstype.scoreId : 0
        this.getresult(this.result, this.ques).resultAnswerValue = anstype.score_value
        this.getresult(this.result, this.ques).resultChoicetypeId = anstype.ansChoicetypeId
        this.getresult(this.result, this.ques).resultScoreValue = anstype.score_value
        var result = this.getresult(this.result, this.ques)
        this.getresult(this.result, this.ques).resultIsSkipped = false
        if (!anstype.innerChoice) {
          for (var s = 0; s < this.getresult(this.result, this.ques).InnerResult.length; s++) {
            this.getresult(this.result, this.ques).InnerResult[s].innerAnswerValue = "null"
          }
        }
      }
      this.userService
        .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
        .subscribe(
          data => {
            this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
          }

        );


      if (number >= this.number) {
        this.enablepage = false;
        this.completesurvey(popup)
      }
      else if (anstype.innerChoice) {
        this.enablepage = true;
        this.anstype = anstype;
        this.inner = anstype.innerChoice
        if (result.InnerResult[0]) {
          this.inneransvalue = result.InnerResult
        }
        this.modalRef = this.modalService.show(innerchoice, { backdrop: 'static' });
        this.movable()
      }
      else {
        id = id + 1;

        if (id >= this.number) {
          this.complete = true
        }
        this.enablepage = true;
        for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
          if (anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            if (id == this.survey[0].survey.sQuestion[j].qNumber) {
              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
                this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              let input;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; //////console.log(this.inputsurvey)
              break;
            }
          }
          else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {

            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (anstype.ForwardSkipQusId == forwardid) {
                break;
              }

            }
            this.ans = [];
            this.ques = [];
            this.intro = null;

            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            let input;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; //////console.log(this.inputsurvey)
            break;
          }
        }



      }
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_select_any_one.error'));
    }
  }

  nextSingle(id, popup: TemplateRef<any>) {
    this.option = false
    var answer, ans
    let number: string = id;
    if (this.surveyques.branchPattern) {
      this.togglepattern = this.surveyques.branchPattern.split('~BR~');
      for (var f = 0; f < this.togglepattern.length; f++) {
        if (this.togglepattern[f].includes('TOGGLE###qpk')) {
          this.pattern = this.togglepattern[f].split('|');
          if (this.pattern[1])
            var branchques = this.pattern[1].split('_')
          if (branchques[0] == this.ques.questionId) {
            if (this.pattern[2]) {
              ans = this.pattern[2].split('#')
              if (ans[0].includes('^')) {
                ans = ans[0].split('^')
                for (let i = 0; i < ans.length; i++) {
                  if (ans[i] == this.answer[id] ? this.answer[id].ansChoicetypeId : 0) {
                    number = this.number
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                }
              } else {
                if (ans[0] == this.answer[id].ansChoicetypeId) {
                  number = this.number
                  for (var qs = id; qs < this.result.length; qs++) {
                    this.result[qs].resultAnswerValue = ''
                    this.result[qs].InnerResult = [];
                    this.result[qs].multiResult = [];
                    this.result[qs].resultAnswerId = 0
                    this.result[qs].resultChoicetypeId = 0
                    this.result[qs].resultScoreValue = ''
                  }
                }
              }


            }
          }
        }
      }
    }

    //////////console.log(this.answer);



    //////////console.log(this.result)
    //////////console.log(number)

    if (number >= this.number) {
      this.complete = true;
      this.completesurvey(popup);

    }
    else {
      id = id + 1;


      for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {

        for (var l = 0; l < this.ans.length; l++) {
          if (this.ans[l].ForwardSkipQusId != null) {

            ans = this.ans[l].ForwardSkipQusId
          }
        }
        if (ans == "" || !ans) {
          if (id == this.survey[0].survey.sQuestion[j].qNumber) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            this.mulans = null;
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            this.mulans = null;
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = [];
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            let input;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; //////console.log(this.inputsurvey)
            break;
          }
        }
        else if (ans == this.survey[0].survey.sQuestion[j].questionId) {
          let forwardid = this.ques.questionId + 1
          for (var t = 0; t < this.result.length; t++) {
            if (this.result[t].resultQuestionId == forwardid) {
              this.result[t].resultIsSkipped = true
              this.result[t].resultAnswerValue = ''
              forwardid = forwardid + 1
            }
            if (ans == forwardid) {
              break;
            }


          }
          this.ans = [];
          this.ques = [];
          this.intro = null;
          this.ques = this.survey[0].survey.sQuestion[j];
          if ((this.ques.questiontype.toLowerCase()) == 'single')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
            this.padding = '13px'
          else
            this.padding = '68px'
          this.ans = [];
          this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
          if (this.ans.innerChoice) {
            this.inner = this.ans.innerChoice
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
          }
          this.ansvalue = this.getresult(this.result, this.ques);
          if ((this.ques.questiontype.toLowerCase()) == 'single') {
            this.complete = false
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          let input;
          if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'height': answer[0],
                'feet': answer[2]
              }
            }
            else {
              input = {
                'height': '',
                'feet': ''
              }
            }
          }
          else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'input': answer[0]
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          else {
            if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
              input = {
                'input': this.ansvalue.resultAnswerValue
              }
            } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
              input = {
                'input': new Date(this.ansvalue.resultAnswerValue)
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          this.inputsurvey = input; //////console.log(this.inputsurvey)
          break;
        }
        if (number + 1 >= this.number)
          this.complete = true;


      }

    }


  }

  nextinnerques(anstype, i, popup) {

    setTimeout(() => {
      this.nextInnerQues(anstype, i, popup)
    }, 300)
  }
  nextInnerQues(anstype, i, popup) {
    let id = this.ques.qNumber;
    var answer
    let number: number = this.ques.qNumber;
    if (anstype) {
      if (this.surveyques.branchPattern) {
        this.togglepattern = this.surveyques.branchPattern.split('~BR~');
        for (var f = 0; f < this.togglepattern.length; f++) {
          if (this.togglepattern[f].includes('TOGGLE###qpk')) {
            this.pattern = this.togglepattern[f].split('|');
            if (this.pattern[1])
              var branchques = this.pattern[1].split('_')
            if (branchques[0] == this.ques.questionId) {
              if (this.pattern[2]) {
                var ans = this.pattern[2].split('#')
                if (ans[0].includes('^')) {
                  ans = ans[0].split('^')
                  ans.forEach(ansItem => {
                    if (ansItem == anstype.ansChoicetypeId) {
                      number = this.number
                      this.getresult(this.result, this.ques).resultIsSkipped = true
                      this.getresult(this.result, this.ques).resultAnswerValue = ''
                      for (var qs = id; qs < this.result.length; qs++) {
                        this.result[qs].resultAnswerValue = ''
                        this.result[qs].InnerResult = [];
                        this.result[qs].multiResult = [];
                        this.result[qs].resultAnswerId = 0
                        this.result[qs].resultChoicetypeId = 0
                        this.result[qs].resultScoreValue = ''
                      }
                    }
                  })
                } else {
                  if (ans[0] == anstype.ansChoicetypeId) {
                    number = this.number
                    this.getresult(this.result, this.ques).resultIsSkipped = true
                    this.getresult(this.result, this.ques).resultAnswerValue = ''
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                }


              }
            }
          }
        }
      }
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).InnerResult[i] = {
          'innerChoicePk': this.inner[i].innerChoicePk,
          'innerQuestionType': this.inner[i].innerQuestionType,
          'innerAnswerValue': anstype.innerAnsChName
        }
        // Sync inneransvalue with InnerResult for reactive validation
        this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
        if (this.inner[i + 1]) {
          // if ((this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name1') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name2') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name3') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name4')) && anstype.innerAnsChName.toLowerCase() == this.userService.translateText('hospital_portal.mytodos.yes_small.label')) {

          if ((this.inner[i + 1].innerChoicePk == 25 || this.inner[i + 1].innerChoicePk == 28 || this.inner[i + 1].innerQuestionName == 31 || this.inner[i + 1].innerQuestionName == 34) && anstype.innerAnsChName.toLowerCase() == this.userService.translateText('hospital_portal.mytodos.yes_small.label')) {
            this.enableques = true
          }
          // else if ((this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name1') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name2') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name3') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name4')) && anstype.innerAnsChName.toLowerCase() == this.userService.translateText('hospital_portal.mytodos.no_small.label')) {

          else if ((this.inner[i + 1].innerChoicePk == 25 || this.inner[i + 1].innerChoicePk == 28 || this.inner[i + 1].innerChoicePk == 31 || this.inner[i + 1].innerChoicePk == 34) && anstype.innerAnsChName.toLowerCase() == this.userService.translateText('hospital_portal.mytodos.no_small.label')) {
            this.enableques = false
            this.getresult(this.result, this.ques).InnerResult[i + 1] = {
              'innerChoicePk': this.inner[i].innerChoicePk,
              'innerQuestionType': this.inner[i].innerQuestionType,
              'innerAnswerValue': "null"
            }
          }
        }

      }

      if (this.inner.length <= 1) {
        this.modalRef.hide();
        this.userService
          .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
          .subscribe(
            data => {
              this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
            }

          );

        if (number >= this.number) {
          this.completesurvey(popup)
        }
        else {
          id = id + 1;



          for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {


            if (anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) {
              this.ans = [];
              this.ques = [];
              this.intro = null;
              if (id == this.survey[0].survey.sQuestion[j].qNumber) {
                this.ques = this.survey[0].survey.sQuestion[j];
                if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                  this.padding = '13px'
                else
                  this.padding = '68px'
                this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
                if (this.ans.innerChoice) {
                  this.inner = this.ans.innerChoice
                  this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
                }
                this.ansvalue = this.getresult(this.result, this.ques);
                if ((this.ques.questiontype.toLowerCase()) == 'single') {
                  this.complete = false
                  if (this.ansvalue.resultChoicetypeId != 0)
                    this.option = true
                }
                if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                  if (this.ansvalue.resultChoicetypeId != 0)
                    this.option = true
                }
                let input;
                if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                  if (this.ansvalue.resultAnswerValue != 'null') {
                    answer = this.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'height': answer[0],
                      'feet': answer[2]
                    }
                  }
                  else {
                    input = {
                      'height': '',
                      'feet': ''
                    }
                  }
                }
                else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                  if (this.ansvalue.resultAnswerValue != 'null') {
                    answer = this.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'input': answer[0]
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                else {
                  if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                    input = {
                      'input': this.ansvalue.resultAnswerValue
                    }
                  } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                    input = {
                      'input': new Date(this.ansvalue.resultAnswerValue)
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                this.inputsurvey = input; //////console.log(this.inputsurvey)
                break;
              }
            }
            else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {

              let forwardid = this.ques.questionId + 1
              for (var t = 0; t < this.result.length; t++) {
                if (this.result[t].resultQuestionId == forwardid) {
                  this.result[t].resultIsSkipped = true
                  this.result[t].resultAnswerValue = ''
                  forwardid = forwardid + 1
                }
                if (anstype.ForwardSkipQusId == forwardid) {
                  break;
                }

              }
              this.ans = [];
              this.ques = [];
              this.intro = null;

              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              let input;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; //////console.log(this.inputsurvey)
              break;
            }
          }



        }
      }

    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_select_any_one.error'));
    }
  }
  close_reset() {
    this.modalRef.hide()
    this.getresult(this.result, this.ques).resultAnswerValue = ''
    for (var k = 0; k < this.getresult(this.result, this.ques).InnerResult.length; k++) {
      this.getresult(this.result, this.ques).InnerResult[k].innerAnswerValue = "null"
    }
    this.getresult(this.result, this.ques).multiResult = [];
    this.getresult(this.result, this.ques).resultAnswerId = 0
    this.getresult(this.result, this.ques).resultChoicetypeId = 0
    this.getresult(this.result, this.ques).resultScoreValue = ''
    this.userService
      .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
      .subscribe(
        data => {
          this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
        }

      );
  }
  nextinputInnerQues(p, anstype, popup) {
    this.mulans = false;
    var answer
    if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
      for (var k = 0; k < this.getresult(this.result, this.ques).InnerResult.length; k++) {
        if ((this.getresult(this.result, this.ques).InnerResult[k].innerAnswerValue == "null") && this.getresult(this.result, this.ques).InnerResult[k].innerQuestionType.toLowerCase() == 'radio') {
          if (k == 1)
            this.mulans = false
          if ((k > 1 && this.getresult(this.result, this.ques).InnerResult[k - 1].innerAnswerValue.toLowerCase() == "yes" && this.getresult(this.result, this.ques).InnerResult[k].innerAnswerValue == "null"))
            this.mulans = false

        }
        else {
          this.mulans = true
        }

      }
    }
    let id = this.ques.qNumber;
    let number: number = this.ques.qNumber;
    if (this.surveyques.branchPattern) {
      this.togglepattern = this.surveyques.branchPattern.split('~BR~');
      for (var f = 0; f < this.togglepattern.length; f++) {
        if (this.togglepattern[f].includes('TOGGLE###qpk')) {
          this.pattern = this.togglepattern[f].split('|');
          if (this.pattern[1])
            var branchques = this.pattern[1].split('_')
          if (branchques[0] == this.ques.questionId) {
            if (this.pattern[2]) {
              var ans = this.pattern[2].split('#')
              if (ans[0].includes('^')) {
                ans = ans[0].split('^')
                ans.forEach(ansItem => {
                  if (ansItem == anstype.ansChoicetypeId) {
                    number = this.number
                    this.getresult(this.result, this.ques).resultIsSkipped = true
                    this.getresult(this.result, this.ques).resultAnswerValue = ''
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                })
              } else {
                if (ans[0] == anstype.ansChoicetypeId) {
                  number = this.number
                  this.getresult(this.result, this.ques).resultIsSkipped = true
                  this.getresult(this.result, this.ques).resultAnswerValue = ''
                  for (var qs = id; qs < this.result.length; qs++) {
                    this.result[qs].resultAnswerValue = ''
                    this.result[qs].InnerResult = [];
                    this.result[qs].multiResult = [];
                    this.result[qs].resultAnswerId = 0
                    this.result[qs].resultChoicetypeId = 0
                    this.result[qs].resultScoreValue = ''
                  }
                }
              }

            }
          }
        }
      }
    }
    if (p.value && this.mulans) {
      this.enableques = false
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        for (var kq = 0; kq < this.getresult(this.result, this.ques).InnerResult.length; kq++) {
          if (this.inner[kq].innerQuestionType.toLowerCase() == 'textbox')
            this.getresult(this.result, this.ques).InnerResult[kq] = {
              'innerChoicePk': this.inner[kq].innerChoicePk,
              'innerQuestionType': this.inner[kq].innerQuestionType,
              'innerAnswerValue': p.value
            }
        }
      }
      this.userService
        .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
        .subscribe(
          data => {
            this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
          }

        );
      if (number >= this.number) {
        this.complete = true;
        this.completesurvey(popup)
      }
      else {
        id = id + 1;

        for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
          var value = false;
          if (this.ques.quesion = this.userService.translateText('patient_portal.question.home_environment_question')) {

            if (p.value.input == "" || p.value.input == "No" || p.value.input == "no" || p.value.input == "0" || p.value.input == "Zero" || p.value.input == "ZERO") {
              value = true;
            }
          }

          if ((anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) || !value) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            if (id == this.survey[0].survey.sQuestion[j].qNumber) {
              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'single')
                this.complete = false
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
                this.complete = false
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              //this.inneransvalue = this.result[id - 1].InnerResult;
              ////////console.log(this.ansvalue)
              let input;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }

              this.inputsurvey = input; //////console.log(this.inputsurvey)
              ////////console.log(this.inputsurvey)

              break;
            }
          }
          else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {
            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (anstype.ForwardSkipQusId == forwardid) {
                break;
              }

            }
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input = {
              'input': this.ansvalue.resultAnswerValue
            }
            this.inputsurvey = input; //////console.log(this.inputsurvey)
            ////////console.log(this.inputsurvey)
            break;
          }
          if (number + 1 >= this.number)
            this.complete = true;
        }



      }
      this.modalRef.hide();
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.select_all_answer.error'));
    }
  }
  nextinputques(p, id, anstype, popup: TemplateRef<any>, innerchoice) {
    this.option = false
    var answer
    let number: string = id;
    let num: number = this.ques.questionId;
    this.answer[id] = anstype;
    if (this.surveyques.branchPattern) {
      this.togglepattern = this.surveyques.branchPattern.split('~BR~');
      for (var f = 0; f < this.togglepattern.length; f++) {
        if (this.togglepattern[f].includes('TOGGLE###qpk')) {
          this.pattern = this.togglepattern[f].split('|');
          if (this.pattern[1])
            var branchques = this.pattern[1].split('_')
          if (branchques[0] == this.ques.questionId) {
            if (this.pattern[2]) {
              var ans = this.pattern[2].split('#')
              if (ans[0].includes('^')) {
                ans = ans[0].split('^')
                ans.forEach(ansItem => {
                  if (ansItem == anstype.ansChoicetypeId) {
                    number = this.number
                    this.getresult(this.result, this.ques).resultIsSkipped = true
                    this.getresult(this.result, this.ques).resultAnswerValue = ''
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                })
              } else {
                if (ans[0] == anstype.ansChoicetypeId) {
                  number = this.number
                  this.getresult(this.result, this.ques).resultIsSkipped = true
                  this.getresult(this.result, this.ques).resultAnswerValue = ''
                  for (var qs = id; qs < this.result.length; qs++) {
                    this.result[qs].resultAnswerValue = ''
                    this.result[qs].InnerResult = [];
                    this.result[qs].multiResult = [];
                    this.result[qs].resultAnswerId = 0
                    this.result[qs].resultChoicetypeId = 0
                    this.result[qs].resultScoreValue = ''
                  }
                }
              }

            }
          }
        }
      }
    }
    if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
      this.getresult(this.result, this.ques).resultAnswerId = anstype.scoreId ? anstype.scoreId : 0
      if (num == 1065 || num == 1225 || num == 806) {
        if (this.CurrentUser.item.language != 'en_uk')
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.height + ' feet ' + p.value.feet + ' inches'
        else
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.height + ' m ' + p.value.feet + ' cm'
      }
      else if (num == 1066 || num == 1226 || num == 807) {
        if (this.CurrentUser.item.language != 'en_uk')
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.input + ' lbs'
        else
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.input + ' kg'
      } else if ((this.ques.questiontype.toLowerCase()) == 'datetime') {
        if (p.value.input && p.value.input != 'Invalid Date') {
          p.value.input = this.datepipe.transform(this.changeFormatToDate(p.value.input), 'yyyy-MM-dd');
          p.value.input = p.value.input.toString()
        }
        this.getresult(this.result, this.ques).resultAnswerValue = p.value.input
      }
      else
        this.getresult(this.result, this.ques).resultAnswerValue = p.value.input
      this.getresult(this.result, this.ques).resultScoreValue = anstype.score_value
      this.getresult(this.result, this.ques).resultIsSkipped = false
    }
    this.userService
      .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
      .subscribe(
        data => {
          this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
        }

      );


    if (number >= this.number) {
      this.complete = true;
      this.completesurvey(popup)
    }
    else {
      id = id + 1;

      for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
        var value = false;
        if (this.ques.quesion = this.userService.translateText('patient_portal.question.home_environment_question')) {

          if (p.value.input == "" || p.value.input == "No" || p.value.input == "no" || p.value.input == "0" || p.value.input == "Zero" || p.value.input == "ZERO") {
            value = true;
          }
        }

        if ((anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) || !value) {
          this.ans = [];
          this.ques = [];
          this.intro = null;
          if (id == this.survey[0].survey.sQuestion[j].qNumber) {
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            ////////console.log(this.ansvalue)
            let input;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }

            this.inputsurvey = input; //////console.log(this.inputsurvey)
            ////////console.log(this.inputsurvey)

            break;
          }
        }
        else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {
          let forwardid = this.ques.questionId + 1
          for (var t = 0; t < this.result.length; t++) {
            if (this.result[t].resultQuestionId == forwardid) {
              this.result[t].resultIsSkipped = true
              this.result[t].resultAnswerValue = ''
              forwardid = forwardid + 1
            }
            if (anstype.ForwardSkipQusId == forwardid) {
              break;
            }

          }
          this.ans = [];
          this.ques = [];
          this.intro = null;
          this.ques = this.survey[0].survey.sQuestion[j];
          if ((this.ques.questiontype.toLowerCase()) == 'single')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
            this.padding = '13px'
          else
            this.padding = '68px'
          this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
          if (this.ans.innerChoice) {
            this.inner = this.ans.innerChoice
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
          }
          this.ansvalue = this.getresult(this.result, this.ques);
          if ((this.ques.questiontype.toLowerCase()) == 'single') {
            this.complete = false
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          let input = {
            'input': this.ansvalue.resultAnswerValue
          }
          this.inputsurvey = input; //////console.log(this.inputsurvey)
          ////////console.log(this.inputsurvey)
          break;
        }
        if (number + 1 >= this.number)
          this.complete = true;
      }



    }


  }
  checkBoxTickManual(id) {
    document.getElementById(id).click()
  }

  mulques(anstype, m, innerchoice, event) {
    this.option = false

    if (event.target.checked) {
      ////////console.log(anstype.ansChoicetypeId)

      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        if (anstype.choicetype == this.userService.translateText('hospital_portal.profile.none.label') || anstype.choicetype == this.userService.translateText('patient_portal.question.didnt_experienced_complications')) {
          for (var jr = 0; jr < this.getresult(this.result, this.ques).multiResult.length; jr++) {
            this.getresult(this.result, this.ques).multiResult[jr].mulAnswerValue = "null"
            this.getresult(this.result, this.ques).multiResult[jr].mulChoicetypeId = 0
            this.getresult(this.result, this.ques).multiResult[jr].mulScoreValue = "null"
          }
          this.getresult(this.result, this.ques).multiResult[m].mulAnswerValue = anstype.choicetype
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = anstype.ansChoicetypeId
          this.getresult(this.result, this.ques).multiResult[m].mulScoreValue = anstype.score_value
          var result = this.getresult(this.result, this.ques)
          this.getresult(this.result, this.ques).resultIsSkipped = false

        }
        else {
          for (var j = 0; j < this.getresult(this.result, this.ques).multiResult.length; j++) {
            if (this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == this.userService.translateText('hospital_portal.profile.none.label') || this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == this.userService.translateText('patient_portal.question.didnt_experienced_complications')) {
              this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue = "null"
              this.getresult(this.result, this.ques).multiResult[j].mulChoicetypeId = 0
              this.getresult(this.result, this.ques).multiResult[j].mulScoreValue = "null"
            }
          }
          this.getresult(this.result, this.ques).multiResult[m].mulAnswerValue = anstype.choicetype
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = anstype.ansChoicetypeId
          this.getresult(this.result, this.ques).multiResult[m].mulScoreValue = anstype.score_value
          this.getresult(this.result, this.ques).resultIsSkipped = false

        }
        if (!anstype.innerChoice) {
          for (var s = 0; s < this.getresult(this.result, this.ques).InnerResult.length; s++) {
            this.getresult(this.result, this.ques).InnerResult[s].innerAnswerValue = "null"
          }
        }
      }

      if (anstype.innerChoice) {
        this.inner = anstype.innerChoice
        this.anstype = anstype
        if (result.InnerResult[0]) {
          this.inneransvalue = result.InnerResult

        }
        ////////console.log(this.inner)

        this.modalRef = this.modalService.show(innerchoice, { backdrop: 'static' });
        this.movable()
      }
    }
    else if ((!event.target.checked)) {
      for (var jq = 0; jq < this.getresult(this.result, this.ques).multiResult.length; jq++) {
        if (anstype.ansChoicetypeId == this.getresult(this.result, this.ques).multiResult[jq].mulChoicetypeId) {
          this.getresult(this.result, this.ques).multiResult[jq].mulAnswerValue = "null"
          this.getresult(this.result, this.ques).multiResult[jq].mulChoicetypeId = 0
          this.getresult(this.result, this.ques).multiResult[jq].mulScoreValue = "null"
        }
      }
    }

  }
  nextmulques(id, popup: TemplateRef<any>) {
    this.mulans = false
    this.option = false
    var answer
    for (var jw = 0; jw < this.getresult(this.result, this.ques).multiResult.length; jw++) {
      if (this.getresult(this.result, this.ques).multiResult[jw].mulChoicetypeId != 0) {
        this.mulans = true;
      }

    }
    if (this.mulans) {
      let number: string = id;
      this.userService
        .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
        .subscribe(
          data => {
            this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
          }

        );
      if (number >= this.number) {
        this.complete = true;
        this.completesurvey(popup);

      }
      else {
        id = id + 1;


        for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {

          var ans
          for (var l = 0; l < this.ans.length; l++) {
            if (this.ans[l].ForwardSkipQusId != null) {

              ans = this.ans[l].ForwardSkipQusId
            }
          }
          if (ans == "" || !ans) {
            if (id == this.survey[0].survey.sQuestion[j].qNumber) {
              this.ans = [];
              this.ques = [];
              this.intro = null;
              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'single')
                this.complete = false
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
                this.complete = false
              this.mulans = null;
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = [];
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              let input;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; //////console.log(this.inputsurvey)
              break;
            }
          }
          else if (ans == this.survey[0].survey.sQuestion[j].questionId) {
            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (ans == forwardid) {
                break;
              }


            }
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = [];
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226
              || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; //////console.log(this.inputsurvey)
            break;
          }
          if (number + 1 >= this.number)
            this.complete = true;


        }

      }
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_select_any_one.error'));
    }

  }
  slidevalue(event: any) {
    this.slideval = event.value;
  }
  nextslideques(id, anstype, event, popup: TemplateRef<any>) {
    this.option = false
    let number: string = id;
    var answer
    ////////console.log(number)
    //////////console.log(this.result)
    this.answer[id] = anstype
    if (event == undefined) {
      event = 0;
    }
    //////////console.log(this.answer);
    if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
      this.getresult(this.result, this.ques).resultAnswerValue = event
      this.getresult(this.result, this.ques).resultChoicetypeId = anstype.ansChoicetypeId
      this.getresult(this.result, this.ques).resultIsSkipped = false
    }
    //////////console.log(this.result)

    //////////console.log(number)
    this.userService
      .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
      .subscribe(
        data => {
          this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
        }

      );
    if (number >= this.number) {
      this.complete = true;
      this.completesurvey(popup);
    }
    else {
      id = id + 1;
      //////////console.log(anstype);
      this.ansvalue = null
      for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {





        if (anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) {
          if (id == this.survey[0].survey.sQuestion[j].qNumber) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; //////console.log(this.inputsurvey)
            break;
          }
        }
        else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {
          let forwardid = this.ques.questionId + 1
          for (var t = 0; t < this.result.length; t++) {
            if (this.result[t].resultQuestionId == forwardid) {
              this.result[t].resultIsSkipped = true
              this.result[t].resultAnswerValue = ''
              forwardid = forwardid + 1
            }
            if (anstype.ForwardSkipQusId == forwardid) {
              break;
            }

          }
          this.ans = [];
          this.ques = [];
          this.intro = null;
          this.ques = this.survey[0].survey.sQuestion[j];
          if ((this.ques.questiontype.toLowerCase()) == 'single')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
            this.padding = '13px'
          else
            this.padding = '68px'
          this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
          if (this.ans.innerChoice) {
            this.inner = this.ans.innerChoice
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
          }
          this.ansvalue = this.getresult(this.result, this.ques);
          if ((this.ques.questiontype.toLowerCase()) == 'single') {
            this.complete = false
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          let input;
          if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 806)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'height': answer[0],
                'feet': answer[2]
              }
            }
            else {
              input = {
                'height': '',
                'feet': ''
              }
            }
          }
          else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226
            || this.ques.questionId == 807)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'input': answer[0]
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          else {
            if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
              input = {
                'input': this.ansvalue.resultAnswerValue
              }
            } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
              input = {
                'input': new Date(this.ansvalue.resultAnswerValue)
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          this.inputsurvey = input; //////console.log(this.inputsurvey)
          break;
        }
        if (number + 1 >= this.number)
          this.complete = true;


      }
    }
  }
  preques(id) {
    this.option = false
    var answer
    id = id - 1;
    ////////console.log(id)
    ////////console.log(this.result)
    for (var jw = 0; jw < this.survey[0].survey.sQuestion.length; jw++) {
      for (var m = 0; m < this.survey[0].survey.sQuestion[jw].sAnswer.length; m++) {
        if (this.ques.questionId == this.survey[0].survey.sQuestion[jw].sAnswer[m].ForwardSkipQusId) {
          id = jw + 1
          break;
        }
      }
    }
    this.complete = false;
    let index = _.findIndex(this.survey[0].survey.sQuestion, (o: any): any => {
      return o.qNumber == id
    })
    if (index != -1) {
      this.ansvalue = this.getresult(this.result, this.survey[0].survey.sQuestion[index]);
      if (this.getresult(this.result, this.survey[0].survey.sQuestion[index]).InnerResult[0]) {
        this.inneransvalue = this.getresult(this.result, this.survey[0].survey.sQuestion[index]).InnerResult;
      }
    }
    ////////console.log(this.ansvalue)
    for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
      this.intro = null;
      if (id == this.survey[0].survey.sQuestion[j].qNumber && !this.getresult(this.result, this.ques).resultIsSkipped) {
        this.ques = this.survey[0].survey.sQuestion[j];
        this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
        if ((this.ques.questiontype.toLowerCase()) == 'single')
          this.complete = false
        if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
          this.complete = false
        if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
          this.padding = '13px'
        else
          this.padding = '68px'
        if ((this.ques.questiontype.toLowerCase()) == 'single') {
          this.complete = false
          if (this.ansvalue.resultChoicetypeId != 0)
            this.option = true
        }
        if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
          if (this.ansvalue.resultChoicetypeId != 0)
            this.option = true
        }
        let input;
        if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 806)) {

          if (this.ansvalue.resultAnswerValue != 'null') {
            answer = this.ansvalue.resultAnswerValue.split(' ');
            input = {
              'height': answer[0],
              'feet': answer[2]
            }
          }
          else {
            input = {
              'height': '',
              'feet': ''
            }
          }
        }
        else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

          if (this.ansvalue.resultAnswerValue != 'null') {
            answer = this.ansvalue.resultAnswerValue.split(' ');
            input = {
              'input': answer[0]
            }
          }
          else {
            input = {
              'input': ''
            }
          }
        }
        else {
          if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
            input = {
              'input': this.ansvalue.resultAnswerValue
            }
          } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
            input = {
              'input': new Date(this.ansvalue.resultAnswerValue)
            }
          }
          else {
            input = {
              'input': ''
            }
          }
        }
        this.inputsurvey = input; //////console.log(this.inputsurvey)
        break;
      }






    }

  }

  getmenu() {
    this.userService.postuserinfoid('1', this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          this.menu = data[1].menu;

          if (this.menu) {
            for (var i = 0; i < this.menu.length; i++) {
              if (this.menu[i].refName == 'PAT_TWOWAYMESSAGE') {
                this.menustatus = this.menu[i].status

              }
              else if (this.menu[i].refName == 'DIS_PAT_TWOWAYMESSAGE') {
                this.twowaymsg = this.menu[i].status
              }
              else if (this.menu[i].refName == 'DIS_PAT_CKCH_SURVEY') {
                this.chckinsurvey = this.menu[i].status
              }
            }
          }
        })


  }

  getAllSurveyMappingId(surveyList) {
    var IdList = []
    for (var survey of surveyList) {
      IdList.push(survey.Tail.patientSveryMappingId)
    }
    return IdList
  }

  count: any = -1
  associateSurveyListLength: any
  completesurvey(popup: TemplateRef<any>) {
    this.enable = true;
    this.enablepage = false;
    let mode = 'P'
    this.userService
      .postsurvey(this.surveyques, this.result, window.localStorage['Puser'], mode, 1)
      .subscribe(
        data => {
          if (data.item.status == "success") {
            this.savesurvey = data.item.message;
            this.userService
              .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
              .subscribe(data => { });
            this.userService.logAudit("savesurveyresult", 0).subscribe(data => { })
            if (window.localStorage['Puser']) {
              this.userService.getusersession()
                .subscribe(
                  data => {
                    if (data)
                      this.userService.setUser(data[0].patientStageWorkflow[0]);
                  },
                  err => this.userService.purgeAuth()
                );
            }
            // console.log(this.surveyques,"surveyques")
            this.associateSurveyListLength = this.associateSurveyDetails.length
            // console.log(this.associateSurveyListLength,"Length",this.getAllSurveyMappingId(this.associateSurveyDetails).includes(this.name.name))            
            if (this.associateSurveyListLength == 0 && this.getAllSurveyMappingId(this.associateSurveyDetails).includes(this.name.name) == false) {
              // console.log(this.associateSurveyDetails,"associatedSurvey")
              this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
              this.success.componentInstance.assessment = 'assessment';
              this.success.componentInstance.message = 'submitted';
              this.success.componentInstance.fullMessage = this.userService.translateText('patient_portal.assessment.assessment_submit_success.message')

              this.router.navigateByUrl('/patient/dashboard')
            }
            else {
              // console.log(this.associateSurveyDetails,"associatedSurvey")           

              for (var associates of this.associateSurveyDetails) {
                // console.log(associates.Tail.hpsmId, this.surveyques.associateHsmId,associates.Tail.isPatReviewed, associates.Tail.reviewStatus,"Full data")
                if (associates.Tail.hpsmId != this.surveyques.associateHsmId && associates.Tail.isPatReviewed != false) {
                  this.count += 1
                  // console.log(this.count,"count if",this.associateSurveyListLength)
                  // console.log(associates.Tail.hpsmId, this.surveyques.associateHsmId,associates.Tail.isPatReviewed, associates.Tail.reviewStatus,"Not equal")
                  this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
                  this.success.componentInstance.assessment = 'assessment';
                  this.success.componentInstance.message = 'submitted';
                  this.success.componentInstance.fullMessage = this.userService.translateText('patient_portal.assessment.assessment_submit_success.message')

                  this.router.navigateByUrl('/patient/dashboard')
                }
                else if (this.associateReviewConditions.includes(associates.Tail.reviewStatus)) {
                  // console.log(this.associateReviewConditions.includes(associates.Tail.reviewStatus),'present in list')                                         
                  this.count += 1
                  // console.log(this.count,"count elseif",this.associateSurveyListLength)
                  // console.log(associates.Tail.hpsmId, this.surveyques.associateHsmId,associates.Tail.isPatReviewed, associates.Tail.reviewStatus,"equal")                
                  var assesmentDetails = {
                    "name": associates.Tail.patientSveryMappingId,
                    "title": associates.Tail.name,
                    "materialId": associates.Tail.ID
                  }
                  window.localStorage['assesDetails'] = btoa(JSON.stringify(assesmentDetails))
                  this.name = assesmentDetails
                  this.userService
                    .getsurvey(associates.Tail.patientSveryMappingId, window.localStorage['Puser'], 1)
                    .subscribe(
                      data => {
                        // this.associateSurveyDetails=[]
                        this.survey = data;
                        this.enablepage = true;
                        var answer
                        if (data) {
                          this.result = data[1].result;
                          this.surveyques = data[0].survey;
                          this.surveyques.associateHsmId = 457693
                          if (this.surveyques.name.search(this.userService.translateText('patient_portal.assessment.recovery_goals.label')) != -1)
                            this.introonly = false
                          else
                            this.introonly = true
                          //this.number = data[0].survey.sQuestion.length;
                          this.number = 0
                          data[0].survey.sQuestion.forEach((element) => {
                            if (element.active == '1')
                              this.number = this.number + 1
                          });
                          if (this.number == 1)
                            this.complete = true;
                          let index = 0
                          for (var g = 0; g < data[1].result.length; g++) {
                            if ((data[1].result[g].resultAnswerType.toLowerCase() == 'single' && data[1].result[g].resultChoicetypeId == "" && !data[1].result[g].resultIsSkipped) || (data[1].result[g].resultAnswerType.toLowerCase() == 'textbox' && (data[1].result[g].resultAnswerValue == "null" || data[1].result[g].resultAnswerValue == "") && !data[1].result[g].resultIsSkipped) || ((data[1].result[g].resultAnswerType.toLowerCase() == 'sliderbar' || data[1].result[g].resultAnswerType.toLowerCase() == 'c_sliderbar' || data[1].result[g].resultAnswerType.toLowerCase() == 'slider') && (data[1].result[g].resultAnswerValue == "null" || data[1].result[g].resultAnswerValue == "") && !data[1].result[g].resultIsSkipped)) {
                              index = g
                              break;
                            } else if (((data[1].result[g].resultAnswerType.toLowerCase() == 'multiplercsd' || data[1].result[g].resultAnswerType.toLowerCase() == 'multiple') && data[1].result[g].multiResult && !data[1].result[g].resultIsSkipped) || (data[1].result[g].resultAnswerType.toLowerCase() == 'singlenewyn' && data[1].result[g].multiResult && !data[1].result[g].resultIsSkipped)) {
                              let ind = _.findIndex(data[1].result[g].multiResult, (o: any): any => {
                                return o.mulAnswerValue != "null"
                              })
                              if (ind == -1) {
                                index = g
                                break;
                              }
                            }
                          }
                          if (index == 0)
                            this.intro = data[0].survey.introduction;
                          if (this.number - 1 == index)
                            this.complete = true;
                          this.ques = data[0].survey.sQuestion[index];
                          if (this.ques) {
                            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                              this.padding = '13px'
                            else
                              this.padding = '68px'
                            if (((this.ques.questiontype.toLowerCase()) == 'single') || ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')) {
                              this.complete = false;
                              if (this.getresult(this.result, this.ques).resultChoicetypeId != 0)
                                this.option = true
                            }
                            this.ans = data[0].survey.sQuestion[index].sAnswer;
                            if (this.ans.innerChoice) {
                              this.inner = this.ans.innerChoice
                              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult
                            }
                            this.ansvalue = this.getresult(this.result, this.ques);
                            let input;
                            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                              if (this.ansvalue.resultAnswerValue != 'null') {
                                answer = this.ansvalue.resultAnswerValue.split(' ');
                                input = {
                                  'height': answer[0],
                                  'feet': answer[2]
                                }
                              }
                              else {
                                input = {
                                  'height': '',
                                  'feet': ''
                                }
                              }
                            }
                            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                              if (this.ansvalue.resultAnswerValue != 'null') {
                                answer = this.ansvalue.resultAnswerValue.split(' ');
                                input = {
                                  'input': answer[0]
                                }
                              }
                              else {
                                input = {
                                  'input': ''
                                }
                              }
                            }
                            else {
                              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                                input = {
                                  'input': this.ansvalue.resultAnswerValue
                                }
                              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                                input = {
                                  'input': new Date(this.ansvalue.resultAnswerValue)
                                }
                              }
                              else {
                                input = {
                                  'input': ''
                                }
                              }
                            }
                            this.inputsurvey = input; //////console.log(this.inputsurvey)
                            // console.log(this.inputsurvey)

                          }




                        }


                      }

                    );
                  if (this.count > this.associateSurveyListLength + 1) {
                    this.associateSurveyDetails = []
                    // console.log("Associates Over")
                    this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
                    this.success.componentInstance.assessment = this.userService.translateText('patient_portal.activity_board.assessment_a.label')
                    this.success.componentInstance.message = this.userService.translateText('patient_portal.activity_board.submitted.label')
                    this.success.componentInstance.fullMessage = this.userService.translateText('patient_portal.assessment.assessment_submit_success.message')

                    this.router.navigateByUrl('/patient/dashboard')
                  }
                  else {
                    this.associateSurveyDetails.splice(this.associateSurveyDetails.indexOf(associates), 1)
                    // console.log(this.associateSurveyDetails,"after splicing")
                  }
                } else {
                  this.count += 1
                  // console.log(this.count,"count else",this.associateSurveyListLength)
                  if (this.count >= this.associateSurveyListLength) {
                    this.associateSurveyDetails = []
                    // console.log("Associates Over 2")
                    this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
                    this.success.componentInstance.assessment = this.userService.translateText('patient_portal.activity_board.assessment_a.label')
                    this.success.componentInstance.message = this.userService.translateText('patient_portal.activity_board.submitted.label')
                    this.success.componentInstance.fullMessage = this.userService.translateText('patient_portal.assessment.assessment_submit_success.message')

                    this.router.navigateByUrl('/patient/dashboard')
                  }
                  else {
                    this.associateSurveyDetails.splice(this.associateSurveyDetails.indexOf(associates), 1)
                    // console.log(this.associateSurveyDetails,"after splicing")
                  }
                }
              }

            }

          }
          else if (data.item.status == "failure") {
            this.savesurvey = data.item.message;
            this.toastr.toastrConfig.timeOut = this.timeset;
            this.toastr.error(data.item.message)
            this.router.navigateByUrl(`/care/dashboard`)
          }
          // this.modalRef = this.modalService.show(popup, { class: 'modal-sm' });

        }

      );
    this.enable = false;
  }
  getid(id) {
    if (id == 1083) {
      return true
    }
    else {
      return false
    }
  }
  getphid(ques) {
    if (ques.toLowerCase() == this.userService.translateText('patient_portal.question.phone_no_support_person')) {
      return true
    }
    else {
      return false
    }
  }
  getidinner(ques) {
    if (ques.toLowerCase() == this.userService.translateText('patient_portal.question.steps_to_enter_your_home') || ques.toLowerCase() == this.userService.translateText('patient_portal.question.inside_home_stairs') || ques.toLowerCase() == this.userService.translateText('patient_portal.question.phone_no_support_person')) {
      return true
    }
    else {
      return false
    }
  }
  getmin(anst) {
    if (anst) {
      let arrlen = anst.choicetype.split(',')
      return arrlen[0]
    }
  }
  getmax(anstype) {
    if (anstype) {
      let arr = anstype.choicetype.split(',')
      return arr[1]
    }
  }
  checkinvaild(id) {
    //////console.log(id)
  }
  checkinvaild1(id) {
    //////console.log(id)
  }
  gettypetext(id) {
    if (id == 536) {
      return false
    }
    else {
      return true
    }

  }
  getValueType(ques) {
    if (ques.valueType && ques.valueType == 'NUMERIC') {
      return true
    }
    return false
  }
  getValueLength(ques) {
    if (ques.valueLength) {
      return ques.valueLength
    }
    return 200
  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }

  checkempty(id) {
    let date
    //////console.log(id)    
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
      this.inputsurvey.input = ''
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild = false;
    } else {
      this.showinvaild = false;
      this.maxdate = false;
    }
  }
  saveData(number, popup) {
    this.userService
      .partialsurvey(this.name.name, this.result, window.localStorage['Puser'], this.survey[0].survey.surveyPart)
      .subscribe(
        data => {
          if (data) {
            this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
            if (number >= this.number) {
              this.complete = true;
              this.completesurvey(popup)
            }
            else {
              this.router.navigateByUrl(`/patient/dashboard`)
            }
          }
        }
      );
  }
  saveExit(popup) {
    let self = this;
    let number: string = self.ques.qNumber;
    if (self.ques.questiontype.toLowerCase() == 'single') {
      if (this.getresult(this.result, this.ques).resultChoicetypeId != 0) {
        this.saveData(number, popup)
      } else {
        this.router.navigateByUrl(`/patient/dashboard`)
      }
    } else if (self.ques.questiontype.toLowerCase() == 'singlenewyn') {
      this.option = false
      this.mulans = false;
      let index = _.findIndex(this.getresult(this.result, this.ques).multiResult, (o: any): any => {
        return o.mulAnswerValue == "null"
      })
      if (index == -1) {
        let number: string = self.ques.qNumber;
        this.saveData(number, popup)

      } else {
        this.router.navigateByUrl(`/care/patientsummary`)
      }
    }
    else if (self.ques.questiontype.toLowerCase() == 'multiplerscd' || self.ques.questiontype.toLowerCase() == 'multiple') {
      this.option = false
      for (var j = 0; j < this.getresult(this.result, this.ques).multiResult.length; j++) {
        if (this.getresult(this.result, this.ques).multiResult[j].mulChoicetypeId != 0) {
          this.mulans = true;
        }
      }
      if (this.mulans) {
        let number: string = self.ques.qNumber;
        this.saveData(number, popup)
      } else {
        this.router.navigateByUrl(`/patient/dashboard`)
      }

    } else if (self.ques.questiontype.toLowerCase() == 'sliderbar' || self.ques.questiontype.toLowerCase() == 'c_sliderbar' || self.ques.questiontype.toLowerCase() == 'slider') {
      this.option = false
      let number: string = self.ques.qNumber;
      if (self.slideval == undefined) {
        self.slideval = 0;
      }
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).resultAnswerValue = self.slideval
        this.getresult(this.result, this.ques).resultChoicetypeId = self.ans[0].ansChoicetypeId
        this.getresult(this.result, this.ques).resultIsSkipped = false
      }
      this.saveData(number, popup)
    } else if (self.ques.questiontype.toLowerCase() == 'textbox') {
      this.option = false
      let num: number = this.ques.questionId;
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        if (this.inputsurvey.height && this.inputsurvey.feet && !this.inputsurvey.input || this.inputsurvey.input) {
          this.getresult(this.result, this.ques).resultAnswerId = this.ans[0].scoreId ? this.ans[0].scoreId : 0
          if (num == 1065 || num == 1225 || num == 806) {
            if (this.CurrentUser.item.language != 'en_uk')
              this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.height + ' feet ' + this.inputsurvey.feet + ' inches'
            else
              this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.height + ' m ' + this.inputsurvey.feet + ' cm'
          }
          else if (num == 1066 || num == 1226 || num == 807) {
            if (this.CurrentUser.item.language != 'en_uk') {
              if (Number(this.inputsurvey.input) <= 500)
                this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input + ' lbs'
            }
            else
              this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input + ' kg'
          }
          else
            this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input
          this.getresult(this.result, this.ques).resultScoreValue = this.ans[0].score_value
          this.getresult(this.result, this.ques).resultIsSkipped = false
        } else {
          this.inputsurvey.height = ''
          this.inputsurvey.feet = ''
          this.inputsurvey.input = ''
        }
      }
      this.saveData(number, popup)
    }
    else if (self.ques.questiontype.toLowerCase() == 'datetime') {
      this.option = false
      var showloader = true;
      if (this.inputsurvey.input && this.inputsurvey.input != 'Invalid Date')
        this.inputsurvey.input = this.datepipe.transform(this.changeFormatToDate(this.inputsurvey.input), 'yyyy-MM-dd');
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).resultAnswerId = this.ans[0].scoreId ? this.ans[0].scoreId : 0
        this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input
        this.getresult(this.result, this.ques).resultScoreValue = this.ans[0].score_value
        this.getresult(this.result, this.ques).resultIsSkipped = false
      }
      if (this.name.patedit == 'new') {
        this.saveData(number, popup)
      }
      else {
        this.completesurvey(popup)
      }
    }

  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  surveydownloadurl: any = environment.surveydownloadUrl;
  onPrint() {
    let printContents;
    let data: any = {
      preview: true,
      hspPatSurveyId: this.name.name,
      patientSwfId: window.localStorage['Puser'],
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    printContents = this.surveydownloadurl + data
    window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
  }
  getresult(result, ques) {
    let index = _.findIndex(result, (o: any): any => {
      return o.resultQuestionId.toString() == ques.questionId.toString()
    })
    if (index != -1) {
      return result[index]
    } else {
      return ''
    }
  }
  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.CurrentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }
  createRange(number) {
    var items: number[] = [];
    for (var i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }


  getName(name) {
    if (name) {
      let title = name.toLowerCase()
      if (title.search('pain') != -1) {
        return true
      } else
        return false
    } else {
      return false
    }
  }

  sliderOption(anstype) {
    let options: Options = {
      floor: 0,
      ceil: this.getmax(anstype),
      step: 1,
      minRange: this.getmin(anstype),
      maxRange: this.getmax(anstype),
      showTicks: true,
      getLegend: (value: number): any => {
        return value;
      }
    };
    return options
  }

  getInnerChoiceValue(inneransvalue, innerAnsChName) {
    if(inneransvalue && ((typeof inneransvalue == 'string' && inneransvalue != 'null') || typeof inneransvalue == 'number')) return inneransvalue;
    else if(Object.keys(inneransvalue).length > 0 && inneransvalue[innerAnsChName] != null) return Number(inneransvalue[innerAnsChName]);
    return '';
  }
}
